import { put, all, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/users/messages";
import selectors from "rdx/modules/users/selectors";

function* deletePermissionsOperation(action) {
  const { success, data, error } = yield* makeRequest.delete(`/operations/${action.payload.id}`);

  if (success && data) {
    const operations = yield select(selectors.getOperations);
    const idx = operations.indexOf(operations.find((p) => p.id === action.payload.id));
    if (idx > -1) {
      operations.splice(idx, 1);
    }

    yield all([
      put(actions.setRolesList({ operations })),
      put(
        actions.newSuccessEvent({
          message: messages.DELETE_PERMISSION_OPERATION_SUCCESS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_DELETING_PERMISSION_OPERATION,
    });
  }

  return null;
}

export default deletePermissionsOperation;
